import { Box, CircularProgress, Grid, Icon, InputAdornment, Typography } from '@mui/material'
import AdxEmptyState from 'components/reusable/emptyState/AdxEmptyState'
import RecruitmentPagination from 'module/recruitment/reusable/RecruitmentPagination'
import JobAdsCard from './JobAdsCard'
import AdxInput from 'components/custom/AdxInput'
import { useEffect, useState } from 'react'
import { useDebouncedEffect } from 'services/hooks/useDebouncedEffect'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const JobAdsList = ({
  handleChangePage,
  handleChangeRow,
  count,
  rowsPerPage,
  data,
  isLoading,
  error,
  page,
  type,
  setSearch,
}) => {
  //search item
  const [searchItem, setSearchItem] = useState('')
  const handleClearSearch = () => {
    setSearchItem('')
  }

  useEffect(() => {
    setSearchItem('')
  }, [type])

  // set delay for search api
  useDebouncedEffect(
    () => {
      if (searchItem.length > 0) {
        setSearch(`&search=${searchItem}`)
      } else {
        setSearch('')
      }
    },
    [searchItem],
    700
  )

  if (isLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          height: 200,
        }}
      >
        <CircularProgress color="alternate" />
      </Box>
    )
  } else if (error !== null || data === undefined) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
        }}
      >
        <Box
          sx={{
            borderBottom: '1px solid',
            borderBottomColor: 'gray-line.main',
            padding: 2,
            width: '100%',
          }}
        >
          <AdxInput
            placeholder="Search job ad"
            value={searchItem}
            onChange={(e) => setSearchItem(e.target.value)}
            sx={{
              width: { xs: 1, sm: 1 / 3, lg: '40%' },
              '& .MuiInputBase-root': {
                outline: '2px solid',
                outlineColor: '#E5E5E5',
                bgcolor: 'white.main',
              },
            }}
            startAdornment={
              <InputAdornment position="start">
                <Icon>search</Icon>
              </InputAdornment>
            }
            endAdornment={
              searchItem ? (
                <InputAdornment position="end">
                  <Icon onClick={handleClearSearch} sx={{ color: 'error.main', cursor: 'pointer' }}>
                    close
                  </Icon>
                </InputAdornment>
              ) : null
            }
          />
        </Box>
        <AdxEmptyStateV2 title="No current job advertisement" subtitle={null} />
      </Box>
    )
  } else {
    return (
      <Box>
        <Box display="flex" flexDirection="column" gap={0}>
          <Box
            sx={{
              padding: 2,
            }}
          >
            <AdxInput
              placeholder="Search job ad"
              value={searchItem}
              onChange={(e) => setSearchItem(e.target.value)}
              sx={{
                width: { xs: 1, sm: 1 / 3, lg: '40%' },
                '& .MuiInputBase-root': {
                  outline: '2px solid',
                  outlineColor: '#E5E5E5',
                  bgcolor: 'white.main',
                },
              }}
              startAdornment={
                <InputAdornment position="start">
                  <Icon>search</Icon>
                </InputAdornment>
              }
              endAdornment={
                searchItem ? (
                  <InputAdornment position="end">
                    <Icon
                      onClick={handleClearSearch}
                      sx={{ color: 'error.main', cursor: 'pointer' }}
                    >
                      close
                    </Icon>
                  </InputAdornment>
                ) : null
              }
            />
          </Box>
          <Box
            bgcolor="gray-background.main"
            display="flex"
            alignItems="center"
            columnGap={2}
            py={1}
            px={2}
            sx={{ borderTop: 1, borderBottom: 1, borderColor: 'gray-line.main' }}
          >
            {/* if type is not draft */}
            {type !== 'draft' ? (
              <Grid container justifyContent="space-between" alignItems="center">
                <Grid item xs={5}>
                  <Box>
                    <Box display="flex" columnGap={2}>
                      <Typography
                        variant="h4"
                        color="dark-text.main"
                        marginBottom={0.5}
                        align="left"
                      >
                        Job(s)
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" columnGap={3}></Box>
                  </Box>
                </Grid>
                <Grid item xs={1} display="flex" flexDirection="column" alignItems="center">
                  <Typography component="span" variant="body1" color="light-gray-text.main">
                    Matched
                  </Typography>
                </Grid>
                <Grid item xs={1} display="flex" flexDirection="column" alignItems="center">
                  <Typography component="span" variant="body1" color="light-gray-text.main">
                    {/* Application */}
                    Applied
                  </Typography>
                </Grid>
                <Grid item xs={1} display="flex" flexDirection="column" alignItems="center">
                  <Typography component="span" variant="body1" color="light-gray-text.main">
                    {/* Shortlisted */}
                    Interview
                  </Typography>
                </Grid>
                <Grid item xs={1} display="flex" flexDirection="column" alignItems="center">
                  <Typography component="span" variant="body1" color="light-gray-text.main">
                    {/* Expiry */}
                    Hired
                  </Typography>
                </Grid>

                {/* to center the table title , does not have any functionality*/}
                <Grid item>
                  <Icon sx={{ color: 'gray-background.main' }}>more_horiz-rounded</Icon>
                </Grid>
              </Grid>
            ) : (
              <Grid container justifyContent="space-between" alignItems="center">
                <Grid item xs={5}>
                  <Box sx={{ cursor: 'pointer' }}>
                    <Box display="flex" columnGap={2}>
                      <Typography
                        variant="h4"
                        color="dark-text.main"
                        marginBottom={0.5}
                        align="left"
                        // sx={{
                        //   textTransform: 'capitalize',
                        // }}
                      >
                        Job(s)
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" columnGap={3}></Box>
                  </Box>
                </Grid>
                <Grid item xs={2} display="flex" flexDirection="column" alignItems="center">
                  <Typography component="span" variant="body1" color="light-gray-text.main">
                    Last updated on
                  </Typography>
                </Grid>

                {/* to center the table title */}
                <Grid item>
                  <Icon sx={{ color: 'gray-background.main' }}>more_horiz-rounded</Icon>
                </Grid>
              </Grid>
            )}
          </Box>
          <Box maxHeight={'calc(100vh - 500px)'} overflow={'auto'}>
            {data?.map((list, index) => (
              <JobAdsCard
                data={data}
                type={type}
                index={index}
                id={list.id}
                title={list.position_title}
                position={list.position_type}
                state={list.state}
                city={list.city}
                startDate={list.startDate}
                updatedDate={list.updated_at}
                rejected={list.rejected}
                applied={list.aggregates?.applied_count}
                shortlisted={list.aggregates?.shortlisted_count}
                matched={list.aggregates?.matched_count}
                hired={list.aggregates?.hired_count}
                interviewed={list.aggregates?.interview_count}
                createdDate={list.created_at}
              />
            ))}
          </Box>
        </Box>
        <Box display="flex" justifyContent="flex-end" sx={{ width: '100%' }}>
          <RecruitmentPagination
            count={count}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRow}
          />
        </Box>
      </Box>
    )
  }
}
export default JobAdsList
